/** Banner vizibil pe staging (video.wingo.ro). Activ doar dacă VITE_STAGING_BANNER=1. */
export function StagingBanner() {
  if (import.meta.env.VITE_STAGING_BANNER !== '1' && import.meta.env.VITE_STAGING_BANNER !== 'true') {
    return null;
  }
  return (
    <div
      role="status"
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 9999,
        background: '#7a3e12',
        color: '#fff8ef',
        fontSize: 12,
        fontWeight: 600,
        letterSpacing: '0.02em',
        textAlign: 'center',
        padding: '6px 12px',
        borderBottom: '1px solid rgba(255,255,255,0.15)',
      }}
    >
      STAGING — video.wingo.ro · date de test, pot fi resetate
    </div>
  );
}
